import { userAdmin, userSeller } from "@/app/api";
import { ReactNode } from "react";

interface SellerAccessProps {
  children: ReactNode;
}

export async function SellerRoute({ children }: SellerAccessProps) {
  const isSeller = await userSeller();
  const isAdmin = await userAdmin();

  if (isSeller || isAdmin) {
    return <>{children}</>
  }
  return null
}